import { render, staticRenderFns } from "./ResetPrompt.vue?vue&type=template&id=329e8691&scoped=true"
import script from "./ResetPrompt.vue?vue&type=script&lang=js"
export * from "./ResetPrompt.vue?vue&type=script&lang=js"
import style0 from "./ResetPrompt.vue?vue&type=style&index=0&id=329e8691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329e8691",
  null
  
)

export default component.exports